import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
  FAQ_HOW_DOES_THE_TRIAL_WORK_ANSWER,
  FAQ_HOW_DOES_THE_TRIAL_WORK_QUESTION,
} from 'consts/copy';

import type { FaqProps } from '..';

export const FAQ_CORE_CONTENT: FaqProps = {
  header: 'FAQs',
  faqs: [
    {
      question: 'What is Curology?',
      answer:
        'Curology makes a custom skincare formula for you. A licensed dermatology provider evaluates your skin profile, skin type, and medical history, and prescribes a custom mix of three simple ingredients. So whether you’re up against acne, dark spots, or fine lines—you get one bottle that’s all you.',
    },
    {
      question: 'Who makes my custom formula?',
      answer:
        'Curology’s dermatology providers are real, live medical professionals—not bots, not AI. After you sign up, you’re paired with a licensed provider who evaluates your skin and determines which ingredients to prescribe, right from your mobile device. No office visit, no copay. Your provider has your back—and can adjust your formula as your skin changes.',
    },
    {
      question: 'When will I see results?',
      answer:
        'Every Curology member has a different skincare journey. Some see results in weeks—others after a few months. How quickly your skin begins to improve depends on your skin type, the severity of your symptoms, and the ingredients in your custom formula.',
    },
    {
      question: FAQ_HOW_DOES_THE_TRIAL_WORK_QUESTION,
      answer: FAQ_HOW_DOES_THE_TRIAL_WORK_ANSWER,
    },
    {
      question: 'Can I adjust how often I get the products?',
      answer:
        'Once you’ve selected a subscription plan, you can adjust when you receive your next shipment. We’ve designed our shipping cycles around how often most members need refills—but we’ve all got our own routines. Running out? Move up your shipment date. Leftovers? Push your shipment date back. Pause anytime.',
    },
  ],
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
    disclaimerText: DISCLAIMER_CONSULTATION_CANCEL,
  },
};
